import RequestService from './request-service';

/**
 * Freebet Service
 */
export default class FreebetRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.getUserFreebets;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';
    const { authorizationHeaders } = this.$config;
    this.headers = authorizationHeaders;
    this.addHeader('ExternalUserID', APP_SETTINGS.player.id);
    this.getParams = {
      Culture: APP_SETTINGS.player.language || 'en',
    };
  }
}
